export function crptgrf(texto: string, crypt: boolean, cod: number = 50): string {
  let resultado = "";

  for (let i = 0; i < texto.length; i++) {
    const charCode = texto.charCodeAt(i);

    let novoCharCode: number;
    if (crypt) {
      novoCharCode = charCode + cod;
    } else {
      novoCharCode = charCode - cod;
    }

    resultado += String.fromCharCode(novoCharCode);

    cod++; // incrementa o deslocamento a cada caractere
  }

  return resultado;
}